<div class="customer-dashboard">    <!-- Top Navigation Bar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow rounded custom-navbar">
        <div class="container-fluid px-4">
            <!-- Logo -->
            <a class="navbar-brand d-flex align-items-center" href="#">
                <img :src="$clientLogo" width="140px" alt="Logo" class="navbar-logo me-2">
            </a>

            <!-- Mobile menu toggle -->
            <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>            
            
            <!-- Navigation Items -->
            <div class="collapse navbar-collapse" id="navbarNav">
                <div class="navbar-nav ms-auto">
                    <!-- User Navigation Container -->
                    <div class="nav-item user-navigation-wrapper">
                        <!-- User Info Section -->
                        <div class="user-info-section">
                            <i class="fas fa-user-circle"></i>
                            <span class="user-name text-xs">{{ user_name }}</span>
                        </div>
                        <!-- <div class="nav-separator hidden-mobile">|</div> -->
                        <!-- Navigation Links Section -->
                        <div class="nav-actions-section">
                            <div v-if="current_route_name=='assigned_workflows'" class="nav-action-item text-xs" @click="go_to_profile">
                                Profile
                            </div>
                            <div v-if="current_route_name=='customer_profile'" class="nav-action-item text-xs" @click="go_to_assigned_workflows">
                                Assigned Workflows
                            </div>
                            <div class="nav-separator">|</div>
                            <div class="nav-action-item logout-action text-xs" @click="logout_function">
                                Logout
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>

    <!-- Main Content Area -->
    <div class="customer-main-content">
        <router-view :key="$route.fullPath"></router-view>
    </div>
</div>
